import { useQuery } from "@apollo/client";
import React from "react";
import { GET_MERCHANT_POS_DETAILS } from "../../../Qurries";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Table } from "../../../components/Table";
export default function PosDevice() {
  const { data, loading } = useQuery(GET_MERCHANT_POS_DETAILS);

  return (
    <div className="mt-8">
      {loading ? (
        <div className="min-h-[80vh] w-full flex justify-center items-center">
          <AiOutlineLoading3Quarters className="text-3xl animate-spin" />
        </div>
      ) : (
        <Table
          exportBtn={false}
          perPage={false}
          heading={"POS details"}
          srNo={false}
          pagination={true}
          copyContent={[3]}
          data={[
            [
              "Sr.No",
              "POS Name",
              "POS ID",
              "Device Serial No.",
              "Status",
              "Installation Date",
            ],
            ...(data?.getMerchantSchoolPOS?.map((pos: any, index: number) => [
              <div className="cursor-pointer">{index + 1}</div>,
              <div className=" cursor-pointer">
                {pos.machine_name.replace(/_/g, " ")}
              </div>,
              <div className=" cursor-pointer">{pos._id}</div>,
              <div className=" cursor-pointer">
                {pos.machine_details.Device_serial_no}
              </div>,
              <div className=" cursor-pointer">{pos.status}</div>,
              <div className=" cursor-pointer">
                {new Date(pos.installation_date).toDateString()}
              </div>,
            ]) || []),
          ]}
        />
      )}
    </div>
  );
}
